import { isAndroid } from '@/infrastructure/product-info';
import { MetricType } from '@/service/quality-report';


export const getName = (metricType?: MetricType|null) => {
  switch (metricType) {
    case MetricType.TYPE_CRASH:
      return '崩溃率';
    case MetricType.TYPE_ANR:
      return 'ANR率';
    case MetricType.TYPE_FOOM:
      return isAndroid() ? 'OOM率' : 'FOOM率';
    case MetricType.TYPE_LAG_HANG_RATE_NEW:
    case MetricType.TYPE_LAG_HANG_RATE:
    case MetricType.TYPE_LAG_HANG_RATE_NEW:
      return '挂起率';
    case MetricType.TYPE_MEMORY:
      return '内存峰值';
    case MetricType.TYPE_NETWORK:
      return '网络错误率';
    case MetricType.TYPE_LAUNCH:
      return '启动耗时';
    case MetricType.TYPE_PAGE_LAUNCH:
      return '页面性能';
    default:
      return `未知-${metricType}`;
  }
};

export const getRating = (score?: number | null) => {
  if (score === null || score === undefined) {
    return { name: '无', color: '#6b7280', subColor: '#e5e7eb' };
  }
  const number = Number(score?.toFixed(1));
  if (number >= 4.5) {
    return { name: '优秀', color: '#4ade80', subColor: '#86efac' };
  }
  if (number >= 3.5) {
    return { name: '良好', color: '#22d3ee', subColor: '#C9F0E3' };
  }
  if (number >= 2.5) {
    return { name: '一般', color: '#0A6CFF', subColor: '#C2DAFF' };
  }
  if (number >= 1.5) {
    return { name: '较差', color: '#fbbf24', subColor: '#fcd34d' };
  }
  if (number > 0) {
    return { name: '差', color: '#F04352', subColor: '#FFD6D9' };
  }
  return { name: '无', color: '#6b7280', subColor: '#e5e7eb' };
};
